export const documentListingListViewCardsStyles = {
  cardsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
};
